import { render, staticRenderFns } from "./PAF02_Core.vue?vue&type=template&id=16b872ff&scoped=true&"
import script from "./PAF02_Core.vue?vue&type=script&lang=js&"
export * from "./PAF02_Core.vue?vue&type=script&lang=js&"
import style0 from "./PAF02_Core.vue?vue&type=style&index=0&id=16b872ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b872ff",
  null
  
)

export default component.exports